import React from 'react';
import Modal, { ModalProps } from '@components/modal/Modal';
import { Button } from '@ftdr/blueprint-components-react';
import { getCurrentThemeConfig } from '@app/core/theme-config';

export interface ModalConfirmCoverageProps extends ModalProps {
  onAccept?: () => void;
  onDecline?: () => void;
}

const ModalConfirmCoverage: React.FC<ModalConfirmCoverageProps> = (props) => {
  const onAccept = () => {
    props.onAccept?.();
  };

  const onDecline = () => {
    props.onDecline?.();
  };

  const actions = [
    <Button
      key="submit"
      id="coverage-modal--btn-accept"
      label="Accept"
      width="full"
      labelAlign="center"
      size="medium"
      onClick={onAccept}
      className={getCurrentThemeConfig().modalStyleButton}
      color={getCurrentThemeConfig().modalOkStyleButtonColor}
    />,
    <Button
      key="cancel"
      id="coverage-modal--btn-cancel"
      label="Decline"
      width="full"
      labelAlign="center"
      size="medium"
      onClick={onDecline}
      className={getCurrentThemeConfig().modalStyleButton}
      variant="ghost"
    />,
  ];

  return (
    <Modal
      id={props.id}
      heading={props.heading}
      canClose={true}
      actions={actions}
      {...props}
      onClose={onDecline}
    >
      {props.children}
    </Modal>
  );
};

export default ModalConfirmCoverage;
